import moment from 'moment';

import { VisitSummaryItem } from '@vestahealthcare/common/models';
import { DATE_FORMAT } from '@vestahealthcare/common/utils/constants';

import Api, {
  PaginatedResponse,
  PaginationParams,
} from 'dash/src/services/Api';

import { GetPodReportDataParams } from './CCMServices';
import { VestaTeamFilters } from './types';

export type GetVisitSummaryParams = PaginationParams &
  Omit<GetPodReportDataParams, 'referralSource'> &
  Pick<VestaTeamFilters, 'engagementOwnerId' | 'npOwnerId'> & {
    biannualAppointmentStatus?: string;
    biannualStatus?: string;
    ccmMinutesFrom?: number;
    ccmMinutesTo?: number;
    establishedVisitStatus?: string;
    establishedVisitAppointmentStatus?: string;
    excludeAppointmentTypesInPriorMonth?: string[];
    podId?: number[];
    referralSourceId?: string[];
  };

export const fetchVisitSummaryItems = async ({
  month,
  ...params
}: GetVisitSummaryParams): Promise<PaginatedResponse<VisitSummaryItem>> => {
  const {
    visitsSummaryMembers: { items, pagination },
  } = await Api.getv2('visits-summary', {
    month: moment().startOf('month').format(DATE_FORMAT),
    ...(params || {}),
    sort: params?.sort || 'fullName asc, id asc',
  });
  return {
    items: items.map((item: any) => new VisitSummaryItem(item)),
    pagination,
  };
};

export const downloadVisitSummaryExport = async ({
  month,
  ...params
}: GetVisitSummaryParams) => {
  const blob: Blob = await Api.getv2Blob('/visits-summary/export', {
    month: moment().startOf('month').format(DATE_FORMAT),
    ...(params || {}),
    sort: params?.sort || 'fullName asc',
  });
  const csvURL = window.URL.createObjectURL(blob);
  const tempLink = document.createElement('a');
  tempLink.href = csvURL;
  tempLink.setAttribute('download', 'visit_summary_export.csv');
  tempLink.click();
};
